import { usePayee } from '@/payee.composable';
import { nextTick, Ref } from 'vue';

export async function setupStax(staxJsRef: Ref<any>) {
  // stax wasn't really built with vue in mind, we have to wait for the page to finish rendering
  await nextTick();
  await waitFor(300);

  try {
    staxJsRef.value = populateStax();
    await staxJsRef.value.showCardForm();
  } catch(error) {
    console.log(error);
    await waitFor(200);
    staxJsRef.value = populateStax();
    await staxJsRef.value.showCardForm();
  }
}

function populateStax() {
  const { payee } = usePayee();

  // eslint-disable-next-line no-undef,@typescript-eslint/ban-ts-comment
  // @ts-ignore
  return new StaxJs(payee.value?.webPaymentToken, {
    number: {
      id: 'card-number',     // the html id of the div you want to contain the credit card number field
      style: 'height: 40px; width: 100%; font-size: 16px; padding-left: 16px',    // the style to apply to the field
      format: 'prettyFormat'    // the formatting of the CC number (prettyFormat || plainFormat || maskedFormat)
    },
    cvv: {
      id: 'cvv-number',    // the html id of the div you want to contain the cvv field
      style: 'height: 40px; width: 100%; font-size: 16px; padding-left: 16px',
    }
  });
}

function waitFor(ms: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, ms);
  })
}
